<template>
  <div class="animated fadeIn">
    <div class="kt-portlet kt-portlet--mobile" style="position:relative">
      <div class="kt-portlet__body kt-portlet__body--fit" ref="cnt">
        <div class="m-4">
          <div class="container-fluid" v-if="typeof gross_winning != 'undefined'">
            <div class="text-center my-2 mb-4">
              {{$t("Gross Winning")}}:
              <strong>{{round(gross_winning)}}</strong>
              | {{$t("Total Amount")}}:
              <strong>{{round(total_amount)}}</strong>
              | {{$t("Winning Tax")}}:
              <strong>{{round(winning_tax)}}</strong>
            </div>
          </div>
          <div class="filters-container">
            <TableFilters v-model="filterOptions" style="margin-right: 45px" @click="refresh" />
            <DropdownColumns
              v-model="fields"
              class="customize"
              :export-link="exportLink"
              :export-json="exportJson"
            />
          </div>
          <div style="overflow:auto">
            <b-table
              id="dynamic-table"
              :busy.sync="isBusy"
              show-empty
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :hover="true"
              :striped="true"
              stacked="md"
              v-model="copy"
              :items="provider"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              @row-clicked="rowClicked"
              tbody-tr-class="tr-pointer"
              v-columns-resizable="{afterResize: columnsWidthChanged}"
            >
              <template v-slot:head(eid)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eshop_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(etenant_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eterminal_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(euser_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(ticket_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(total_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(stake)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(registration_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(tax)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(event_name)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(event_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(event_code)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(selected_numbers)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(number_of_lines)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(ticket_systems)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(status)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(is_valid)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(gross_winning_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(winning_tax)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(net_winning_amount)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(paid_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(epaid_by_user_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eplayer_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(odds)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(custom_odds)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(is_web_ticket)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(authorized)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(eauthorized_by_user_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(cancel_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(processing_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(processing_routine_id)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(expiration_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(pin)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(save_time)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(max_winning)="data">{{ $t(data.label) }}</template>
              <template v-slot:head(min_winning)="data">{{ $t(data.label) }}</template>

              <template v-slot:cell(total_amount)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(tax)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(stake)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(gross_winning_amount)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(winning_tax)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(net_winning_amount)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(max_winning)="data">{{ roundThousands(data.value) }}</template>
              <template v-slot:cell(min_winning)="data">{{ roundThousands(data.value) }}</template>

              <template v-slot:cell(etenant_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/tenants/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eshop_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/shops/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(event_name)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/lottery-events/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eterminal_id)="data">
                <span v-if="data.value">
                  <span v-if="data.item.eshop_id.to">
                    <router-link :to="`/shops/${data.item.eshop_id.to}`">{{ data.value }}</router-link>
                  </span>
                  <span v-else>{{ data.value }}</span>
                </span>
              </template>

              <template v-slot:cell(euser_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/users/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(epaid_by_user_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/users/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eauthorized_by_user_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/users/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(eplayer_id)="data">
                <span v-if="data.value">
                  <span v-if="data.value.to">
                    <router-link :to="`/players/${data.value.to}`">{{ data.value.name }}</router-link>
                  </span>
                  <span v-else>{{ data.value.name }}</span>
                </span>
              </template>

              <template v-slot:cell(status)="data">{{$t(data.value)}}</template>
              <template v-slot:cell(is_valid)="data">{{$t(data.value)}}</template>

              <template
                v-slot:cell(registration_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>
              <template
                v-slot:cell(event_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>
              <template
                v-slot:cell(paid_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>
              <template
                v-slot:cell(cancel_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>
              <template
                v-slot:cell(processing_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>
              <template
                v-slot:cell(expiration_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>
              <template
                v-slot:cell(save_time)="data"
              >{{ mom_unix(data.value).format(tableDateMedium) }}</template>

              <template v-slot:empty="scope">
                <div class="text-center">{{ $t(scope.emptyText) }}</div>
              </template>
            </b-table>
          </div>
          <div class="container-fluid">
            <div class="row">
              <div style="white-space:nowrap;" class="my-2">
                <PaginationSelect
                  v-model="perPage"
                  :options="paginationOpts"
                  variant="light"
                  size="sm"
                />
                <span>
                  &nbsp;
                  <i18n path="Showing {start}-{end} of {total} rows" tag="span">
                    <span slot="start">{{(currentPage-1) * perPage + 1}}</span>
                    <span slot="end">{{currentPage * perPage}}</span>
                    <span slot="total">{{totalRows}}</span>
                  </i18n>
                </span>
                <b-button
                  size="sm"
                  @click.stop="$root.$emit('bv::refresh::table', 'dynamic-table')"
                  class="ml-2 refresh"
                  variant="light"
                  :title="$t('Refresh')"
                >
                  <i class="icon-refresh"></i>
                </b-button>
              </div>
              <nav class="ml-auto mt-2">
                <b-pagination
                  size="md"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  v-model="currentPage"
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import startCase from "@/shared/strings";
import { errorConf } from "@/shared/notifications";
import tableMixin from "@/shared/mixins/table.mixin";
import PaginationSelect from "@/components/PaginationSelect";
import DropdownColumns from "@/components/DropdownColumns";
import TableFilters from "@/components/TableFilters";

export default {
  name: "expiredWinnings",
  mixins: [tableMixin],
  components: {
    PaginationSelect,
    DropdownColumns,
    TableFilters
  },
  data: function() {
    return {
      tableName: "expiredWinnings",
      filterOptions: [
        {
          field: "test",
          multiple: false,
          placeholder: "Test",
          options: [
            { name: "Test Mode", value: true },
            { name: "Live Mode", value: false }
          ],
          selected: [{ name: "Live Mode", value: false }]
        },
        {
          field: "save_time",
          type: "date",
          opens: "right",
          selected: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          default: {
            startDate: moment().startOf("day"),
            endDate: moment().endOf("day")
          },
          ranges: {
            "Last hour": [moment().subtract(1, "hour"), moment()],
            "Last 6 hours": [moment().subtract(6, "hours"), moment()],
            "Last 24 hours": [moment().subtract(24, "hours"), moment()],
            Today: [moment().startOf("day"), moment().endOf("day")],
            Yesterday: [
              moment()
                .subtract(1, "days")
                .startOf("day"),
              moment()
                .subtract(1, "days")
                .endOf("day")
            ],
            "This week": [
              moment().startOf("isoWeek"),
              moment().endOf("isoWeek")
            ],
            "Last week": [
              moment()
                .subtract(1, "week")
                .startOf("isoWeek"),
              moment()
                .subtract(1, "week")
                .endOf("isoWeek")
            ],
            "This month": [moment().startOf("month"), moment().endOf("month")],
            "Last month": [
              moment()
                .subtract(1, "month")
                .startOf("month"),
              moment()
                .subtract(1, "month")
                .endOf("month")
            ],
            "This year": [moment().startOf("year"), moment().endOf("year")],
            "Last year": [moment().subtract(1, "year"), moment()]
          }
        }
      ],
      isBusy: false,
      sortBy: "save_time",
      sortDesc: true,
      fields: [
        {
          key: "eid",
          label: "Id",
          sortable: false,
          ignore: true,
          class: "d-none"
        },
        {
          key: "etenant_id",
          label: "Tenant",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "eshop_id",
          label: "Shop",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "eterminal_id",
          label: "Terminal",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "euser_id",
          label: "User",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "ticket_id",
          label: "Serial",
          sortable: true,
          class: ""
        },
        { key: "event_name", sortable: true, class: "" },
        { key: "event_time", sortable: true, class: "", ignore: true },
        { key: "event_code", sortable: true, class: "d-none" },
        {
          key: "total_amount",
          label: "Total Amount",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "registration_time",
          label: "Registration",
          sortable: true,
          ignore: true,
          class: ""
        },
        {
          key: "stake",
          label: "Stake",
          sortable: true,
          ignore: true,
          class: "d-none"
        },
        {
          key: "tax",
          label: "Tax",
          sortable: true,
          ignore: true,
          class: "d-none"
        },

        {
          key: "selected_numbers",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        {
          key: "number_of_lines",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        { key: "ticket_systems", sortable: false, class: "", ignore: true },
        { key: "status", sortable: true, class: "", ignore: true },
        { key: "is_valid", sortable: true, class: "", ignore: true },
        {
          key: "gross_winning_amount",
          sortable: true,
          class: "",
          ignore: true
        },
        { key: "winning_tax", sortable: true, class: "", ignore: true },
        {
          key: "net_winning_amount",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        { key: "paid_time", sortable: true, class: "", ignore: true },
        {
          key: "epaid_by_user_id",
          label: "Paid by User",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        {
          key: "eplayer_id",
          label: "Player",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        { key: "odds", sortable: true, class: "d-none", ignore: true },
        { key: "custom_odds", sortable: true, class: "d-none", ignore: true },
        { key: "is_web_ticket", sortable: true, class: "d-none", ignore: true },
        { key: "authorized", sortable: true, class: "d-none", ignore: true },
        {
          key: "eauthorized_by_user_id",
          label: "Authorized by User Id",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        { key: "cancel_time", sortable: true, class: "d-none", ignore: true },
        {
          key: "ecancel_by_user_id",
          label: "Canceled by User Id",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        {
          key: "processing_time",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        {
          key: "processing_routine_id",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        {
          key: "expiration_time",
          sortable: true,
          class: "d-none",
          ignore: true
        },
        { key: "pin", sortable: true, class: "d-none", ignore: true },
        { key: "save_time", sortable: true, class: "d-none", ignore: true },
        { key: "max_winning", sortable: true, class: "d-none", ignore: true },
        { key: "min_winning", sortable: true, class: "d-none", ignore: true }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      filter: null,
      filterField: null,
      checkAll: false,
      copy: null,
      addLabel: "",

      gross_winning: 0,
      total_amount: 0,
      winning_tax: 0
    };
  },
  computed: {
    lang() {
      return this.$store.getters["global/defLanguage"];
    },
    exportLink() {
      const apiUrl = this.$store.getters["global/apiUrl"];
      const endpoint = this.$store.getters["expiredWinning/endpoint"];

      return `${apiUrl}/${endpoint}s?export=xls&lang=${this.lang}`;
    },
    exportJson() {
      const fields = [];
      this.fields.forEach(item => {
        if (
          typeof item.class != "undefined" &&
          item.class.indexOf("d-none") == -1
        ) {
          let key = item.key;
          if (key != "selected") {
            const efields = [
              "eid",
              "ecancel_by_user_id",
              "eauthorized_by_user_id",
              "eplayer_id",
              "epaid_by_user_id",
              "euser_id",
              "eterminal_id",
              "eshop_id",
              "etenant_id"
            ];

            if (efields.indexOf(key) > -1) {
              key = key.substr(1);
            }

            fields.push(key);
          }
        }
      });

      const paginationData = this.buildPagination();

      paginationData.fields = fields;

      return JSON.stringify(paginationData);
    }
  },
  methods: {
    refresh() {
      this.$root.$emit("bv::refresh::table", "dynamic-table");
    },
    provider(ctx, callback) {
      const loading = this.$loading.open({
        container: this.$refs.cnt
      });

      const paginationData = this.buildPagination();

      const tenantByID = this.$store.getters["cache/tenantByID"];
      const userByID = this.$store.getters["cache/userByID"];
      const shopByID = this.$store.getters["cache/shopByID"];
      const playerByID = this.$store.getters["cache/playerByID"];

      const status = ["Open", "Winner", "Lost", "Paid", "Expired"];
      const is_valid = [
        "Canceled",
        "Valid",
        "Rejected",
        "Manual Authorization",
        "Authorized"
      ];

      Promise.all([
        this.$store.dispatch("cache/fetch", "tenants").catch(e => e),
        this.$store.dispatch("cache/fetch", "users").catch(e => e),
        this.$store.dispatch("cache/fetch", "shops").catch(e => e),
        this.$store.dispatch("cache/fetch", "players").catch(e => e)
      ]).finally(() => {
        this.$store
          .dispatch("expiredWinning/fetch", paginationData)
          .then(resp => {
            this.totalRows = resp.data.total;

            if (typeof resp.data.total_win_gross_amount != "undefined") {
              this.gross_winning = resp.data.total_win_gross_amount;
              this.total_amount = resp.data.total_win_net_amount;
              this.winning_tax = resp.data.total_win_tax;
            }

            resp.data.rows.forEach((item, index) => {
              if (item.etenant_id) {
                const data = tenantByID(item.etenant_id);
                if (data) {
                  item.etenant_id = {
                    to: item.etenant_id,
                    name: data.brand_name
                  };
                } else {
                  item.etenant_id = {
                    to: null,
                    name: item.etenant_id
                  };
                }
              }

              if (item.euser_id) {
                const data = userByID(item.euser_id);
                if (data) {
                  item.euser_id = {
                    to: item.euser_id,
                    name: data.username
                  };
                } else {
                  item.euser_id = {
                    to: null,
                    name: item.euser_id
                  };
                }
              }

              if (item.eshop_id) {
                const data = shopByID(item.eshop_id);
                if (data) {
                  item.eshop_id = {
                    to: item.eshop_id,
                    name: data.name
                  };
                } else {
                  item.eshop_id = {
                    to: null,
                    name: item.eshop_id
                  };
                }
              }

              if (item.event_name) {
                item.event_name = {
                  to: item.eevent_id,
                  name: item.event_name
                };
              }

              if (item.epaid_by_user_id) {
                const data = userByID(item.epaid_by_user_id);
                if (data) {
                  item.epaid_by_user_id = {
                    to: item.epaid_by_user_id,
                    name: data.username
                  };
                } else {
                  item.epaid_by_user_id = {
                    to: null,
                    name: item.epaid_by_user_id
                  };
                }
              }

              if (item.eauthorized_by_user_id) {
                const data = userByID(item.eauthorized_by_user_id);
                if (data) {
                  item.eauthorized_by_user_id = {
                    to: item.eauthorized_by_user_id,
                    name: data.username
                  };
                } else {
                  item.eauthorized_by_user_id = {
                    to: null,
                    name: item.eauthorized_by_user_id
                  };
                }
              }

              if (item.eplayer_id) {
                const data = userByID(item.eplayer_id);
                if (data) {
                  item.eplayer_id = {
                    to: item.eplayer_id,
                    name: `${data.name} ${data.surname}`
                  };
                } else {
                  item.eplayer_id = {
                    to: null,
                    name: item.eplayer_id
                  };
                }
              }
              if (item.status == 1) {
                resp.data.rows[index]["_cellVariants"] = {
                  status: "success"
                };
              }
              item.status = status[item.status];

              item.is_valid = is_valid[item.is_valid];
            });
            callback(resp.data.rows);
          })
          .catch(err => {
            this.$bvToast.toast(
              this.$t(
                err.details && err.details.length ? err.details[0] : err.message
              ),
              errorConf(this.$t("Error"))
            );
            this.totalRows = 0;
            callback([]);
          })
          .finally(() => {
            loading.close();
          });
      });

      // Must return null or undefined to signal b-table that callback is being used
      return null;
    },
    buildPagination() {
      const paginationData = {
        rowsPerPage: this.perPage,
        page: this.currentPage
      };

      if (this.filter && this.filterField) {
        paginationData.likeValues = [this.filter];
        paginationData.likeFields = [this.filterField];
      } else {
        paginationData.likeValues = [];
        paginationData.likeFields = [];
      }

      if (this.sortBy) {
        let sortBy = this.sortBy;
        if (sortBy == "etenant_id") sortBy = "tenant_id";
        if (sortBy == "eshop_id") sortBy = "shop_id";
        if (sortBy == "eterminal_id") sortBy = "terminal_id";
        if (sortBy == "euser_id") sortBy = "user_id";
        if (sortBy == "epaid_by_user_id") sortBy = "paid_by_user_id";
        if (sortBy == "eplayer_id") sortBy = "player_id";
        if (sortBy == "eauthorized_by_user_id")
          sortBy = "authorized_by_user_id";
        if (sortBy == "ecancel_by_user_id") sortBy = "cancel_by_user_id";
        paginationData.sortBy = [sortBy];
        paginationData.sortDirection = [this.sortDesc ? "DESC" : "ASC"];
      }

      const exactFields = [];
      const exactValues = [];

      this.filterOptions.forEach(item => {
        if (item.type != "date" && item.selected.length) {
          exactFields.push(item.field);
          exactValues.push(item.selected);
        } else if (item.type == "date") {
          if (item.selected.startDate && item.selected.endDate) {
            paginationData.dateField = item.field;
            paginationData.dateStart = item.selected.startDate;
            paginationData.dateEnd = item.selected.endDate;
          } else {
            paginationData.dateField = item.field;
            paginationData.dateStart = moment().startOf("day");
            paginationData.dateEnd = moment().endOf("day");
          }
        }
      });

      if (exactFields.length) {
        paginationData.exactFields = exactFields;
        paginationData.exactValues = exactValues;
      }
      return paginationData;
    },
    rowClicked(item, index, event) {
      //this.$router.push("/expired-winnings/" + item.eid);
    },
    redirect() {}
  }
};
</script>

<style lang="scss" scoped>
</style>


